import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import './Slider.css';
import slider1 from '../../assets/img/gallery/img4.jpg';
import slider2 from '../../assets/img/gallery/img3.jpg';

const config = require("../../config.json");


const NewSlider = () => {
  const slides = [
    {
      id: 1,
      //image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1600&q=80",
      image: slider1,
      title: "Explore the Wild",
      subtitle: "Experience nature like never before."
    },
    {
      id: 2,
      //image: "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&w=1600&q=80",
      image: slider2,
      title: "Mountain Escapes",
      subtitle: "Find your peace in the high altitudes."
    }
  ];

  const [loaded, setLoaded]=useState(false);
  const [galleryImages, setGalleryImages] = useState([]);

  useEffect(()=>{
    fetchGalleryImages();
  },[])

   const fetchGalleryImages =async()=>{
        try{
            setLoaded(false);
        const fileName='images/slider';
        const bucketName=config.s3.bucketName;
      await axios.get(`${config.api.invokeURL}/dashboard/website/slider?fileName=${fileName}&bucketName=${bucketName}`,{
            headers: {
              //Authorization: access_token,
              'x-api-key': config.api.key
            }}, 
        ).then((response)=>{
            //console.log("Response : ", response);
            const finalList=[];
            if(response.data.length>0){
              for (const i in response.data){
                const tValue=response.data[i];
                const tPathName=tValue.split("/");
                const tBreakUp=tPathName[2];
                const tempValue={};
                tempValue.fullPathName=response.data[i];
                tempValue.fileName=tBreakUp;
               // const tdoctorName=tBreakUp[1];
               // const tempDName=tdoctorName.split(".");
               // tempValue.doctorName=tempDName[0];
               // console.log("tempvalue : ", tempValue);
               // tempValue.projectSize=tBreakUp[2];
                //tempValue.projectDate=tBreakUp[3];
                finalList.push(tempValue);
              }
            }
      
           // console.log(finalList);
            setGalleryImages(finalList);
            //setDispMsg(response.data.length + " - Images are found in your Gallery");
          //  enqueueSnackbar(response.data.length + " - Images are found in Slider section",{variant : 'success'});
            setLoaded(true);
            window.scrollTo(0,0); 
        }).catch((error)=>{
            console.log(error.message);
            //setDispMsg(error.message);
            //enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
            setLoaded(true);
            window.scrollTo(0,0); 
        })
    }catch(error){
       // setDispMsg(error.message);
      //  enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        setLoaded(true);
        window.scrollTo(0,0); 
    }
    setLoaded(true);
}


  return (
    // ensure slider is above overlays (z-index may be used by surrounding layout)
    <div id="topSlider" className="carousel slide carousel-fade" data-bs-ride="carousel" style={{position: 'relative', zIndex: 3}}>
      {/* if API returned images use them, otherwise fall back to local sample slides */}
      {(() => {
        const displayedImages = galleryImages.length > 0 ? galleryImages : slides;
        if (!displayedImages || displayedImages.length === 0) return null;
        return (
          <div className="carousel-inner">
            {displayedImages.map((item, index) => {
              // determine background image for API items vs local sample slides
              const bg = item.fullPathName
                ? (item.fullPathName.startsWith('http') ? item.fullPathName : `${config.s3.imageUrl}${item.fullPathName}`)
                : item.image;
              return (
                <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`} data-bs-interval="5000">
                  <div className="slider-image-container">
                    <div
                      className="slider-image-blur"
                      style={{ backgroundImage: `url(${bg})` }}
                      aria-hidden="true"
                    />
                    <img
                      src={bg}
                      alt={item.title || `Slide ${index + 1}`}
                      className="slider-image-main"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        );
      })()}

      {/* show controls only when there is more than one slide */}
      { (galleryImages.length > 1 || slides.length > 1) && (
        <>
          <button className="carousel-control-prev" type="button" data-bs-target="#topSlider" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#topSlider" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
          </button>
        </>
      )}
    </div>
  );
};

export default NewSlider;